<template>
    <div>

        <div v-if="!loading" class="d-flex">
            <SingleBlock
                :color="color"
                :target="target"
                :progress="progress"/>
        </div>

        <MoonSpinner v-else color="#F9F9F9" :loading="true"/>

    </div>
</template>

<script>

    import SingleBlock from '@/components/graphs/partials/Single';

    import MoonSpinner from "@/components/spinners/MoonSpinner";

    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'AppealDonationGraph',
        components: {SingleBlock, MoonSpinner},

        props: {
            postId: {
                type: String,
                required: true
            },
            color: {
                type: String,
                required: true
            }
        },

        computed: {
            ...mapGetters('Donations', {
                loading: 'fetchingDonations',
                target: 'target',
                progress: 'totalDonationsValue'
            })
        },

        created() {
            this.loadData();
        },

        methods: {
            ...mapActions('Donations', ['donations']),

            loadData() {
                this.donations({postId: this.postId});
            },
        }
    }

</script>
